_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[22],{

/***/ "+UG1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCartSettings; });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);


var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_0___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var staticsUrl = publicRuntimeConfig.grandvision.staticsUrl;
var getCartSettings = function getCartSettings(formatProductUrl, productRoutes) {
  return {
    readOnly: false,
    productRoutes: productRoutes,
    maximumQuantity: 4,
    allowBackOrder: false,
    isDiscountCodeEnabled: true,
    showCartDiscountDescriptions: true,
    showShippingMethod: true,
    showSubTotal: true,
    showTotalDiscount: true,
    staticsUrl: staticsUrl,
    formatProductUrl: formatProductUrl
  };
};

/***/ }),

/***/ "+f1E":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cart",
      function () {
        return __webpack_require__("Jwq0");
      }
    ]);
  

/***/ }),

/***/ "Jwq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("ODXe");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("cIxt");
/* harmony import */ var _grandvision_common__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("ytpp");
/* harmony import */ var _grandvision_elements__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("m5xE");
/* harmony import */ var _grandvision_carts__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("ioLe");
/* harmony import */ var _grandvision_carts_v2__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("qEec");
/* harmony import */ var _grandvision_state__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("k3MI");
/* harmony import */ var _util_cart_settings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("+UG1");
/* harmony import */ var _util_feature_toggle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ns9e");
/* harmony import */ var _components_layout_props__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("hse5");





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_4___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var staticsUrl = publicRuntimeConfig.grandvision.staticsUrl;
var layoutSettings = {
  navigation: false
};

var getCartItemImageUrl = function getCartItemImageUrl(item) {
  return _grandvision_carts__WEBPACK_IMPORTED_MODULE_8__[/* Utils */ "g"].getItemImageUrl(staticsUrl, item);
};

var CartPage = function CartPage(_ref) {
  var store = _ref.store;

  var _useIntl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_10__[/* useIntl */ "Q"])(),
      getLabel = _useIntl.getLabel;

  var _useBloomreachProduct = Object(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_5__[/* useBloomreachProductRoutes */ "p"])(),
      _useBloomreachProduct2 = Object(_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_useBloomreachProduct, 3),
      formatProductUrl = _useBloomreachProduct2[1].formatProductUrl,
      productRoutes = _useBloomreachProduct2[2];

  var goToCheckout = react__WEBPACK_IMPORTED_MODULE_3__["useCallback"](function () {
    var _window;

    (_window = window) === null || _window === void 0 ? void 0 : _window.location.assign('/checkout');
  }, []);
  var goToPreviousPage = react__WEBPACK_IMPORTED_MODULE_3__["useCallback"](function () {
    var _window2;

    (_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.history.back();
  }, []);
  var cart = react__WEBPACK_IMPORTED_MODULE_3__["useMemo"](function () {
    var settings = Object(_util_cart_settings__WEBPACK_IMPORTED_MODULE_11__[/* getCartSettings */ "a"])(formatProductUrl, productRoutes);
    var props = {
      getItemImageUrl: getCartItemImageUrl
    };
    return Object(_util_feature_toggle__WEBPACK_IMPORTED_MODULE_12__[/* isCartV2Enabled */ "c"])() ? /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_carts_v2__WEBPACK_IMPORTED_MODULE_9__[/* Cart */ "b"], _objectSpread(_objectSpread({}, props), {}, {
      settings: settings,
      goToCheckout: goToCheckout,
      goToPreviousPage: goToPreviousPage
    })) : /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_carts__WEBPACK_IMPORTED_MODULE_8__[/* Cart */ "c"], _objectSpread(_objectSpread(_objectSpread({}, props), settings), {}, {
      onPrimaryClick: goToCheckout,
      onSecondaryClick: goToPreviousPage
    }));
  }, [productRoutes, formatProductUrl, goToCheckout, goToPreviousPage]);
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_5__[/* CmsContainerPage */ "d"], {
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsxs"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_5__[/* CmsPageLayout */ "g"], _objectSpread(_objectSpread({}, _components_layout_props__WEBPACK_IMPORTED_MODULE_13__[/* layoutProps */ "a"]), {}, {
      layoutSettings: layoutSettings,
      children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_5__[/* CmsComponentSlot */ "c"], {
        path: "main/top-container"
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_state__WEBPACK_IMPORTED_MODULE_10__[/* ReduxPersistGate */ "m"], {
        loading: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_6__[/* LoaderScreen */ "M"], {}),
        persistor: store.persistor,
        children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsxs"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_7__[/* Container */ "d"], {
          className: "cart-layout",
          children: [cart, /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_6__[/* SupportFooter */ "ob"], {
            message: getLabel('support.title'),
            phoneNumber: getLabel('support.phoneNumber')
          })]
        })
      })]
    }))
  });
};

/* harmony default export */ __webpack_exports__["default"] = (CartPage);

/***/ }),

/***/ "hse5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return layoutProps; });
/* harmony import */ var _babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("rePB");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _grandvision_common__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("ytpp");
/* harmony import */ var _grandvision_carts_v2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("qEec");
/* harmony import */ var _util_feature_toggle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("ns9e");



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { Object(_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var layoutProps = {
  renderCartButton: function renderCartButton(item) {
    var _item$link;

    var props = {
      key: item.label,
      label: item.label,
      href: (_item$link = item.link) === null || _item$link === void 0 ? void 0 : _item$link.href,
      className: 'header-menu__icon'
    };
    return Object(_util_feature_toggle__WEBPACK_IMPORTED_MODULE_5__[/* isCartV2Enabled */ "c"])() ? /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_grandvision_carts_v2__WEBPACK_IMPORTED_MODULE_4__[/* CartButton */ "c"], _objectSpread({}, props)) : /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__["jsx"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_3__[/* CartButton */ "i"], _objectSpread({}, props));
  }
};

/***/ }),

/***/ "mOvS":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("yLiY")


/***/ }),

/***/ "ns9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAABEnabled; });
/* unused harmony export isABTestingEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAddressBookEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isMyAccountEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isContactLensEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isContactLensStockEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCrossSellEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isReviewsEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSolutionsEnabled; });
/* unused harmony export isSearchEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isVtoEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isGPSEnabled; });
/* unused harmony export isPlacePredictionsEnabled */
/* unused harmony export isMultilingualEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isPrescriptionGlassesEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isPrescriptionGlassesConfiguratorValidationStepEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isPrescriptionFileEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isStoreSearchEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isSubscriptionHasOneAddressEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isSubscriptionUpdateAddressEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCartV2Enabled; });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/**
 * This exposes functions that will return true when a feature toggle has been set.
 * It will work both on the server and client
 *
 * To enable a feature:
 *
 *  1) Find the feature name in the `Feature` type below, for instance 'MYACCOUNT'
 *  2) Set an env var using the FEATURE_ prefix when starting the server, ie FEATURE_MYACCOUNT
 *  3) Run the app with `FEATURE_MYACCOUNT=true yarn serve` in dev mode or you can add it the .env file
 *
 * To add a feature toggle
 *
 *  1) Add a name to the Feature type, AWESOME_SAUCE for example,
 *      ex: `| 'AWESOME_SAUCE'`
 *  2) Export a function named isAwesomeSauceEnabled
 *      ex: `export const isAwesomeSauceEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'AWESOME_SAUCE')`
 *  3) To enable it see above
 */

var enabledFeatures;

var getEnabledFeatures = function getEnabledFeatures() {
  if (!enabledFeatures) {
    enabledFeatures = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig.grandvision.features;

    if (false) {}
  }

  return enabledFeatures;
};

var isFeatureEnabled = function isFeatureEnabled(feature) {
  return getEnabledFeatures().some(function (e) {
    return e.toUpperCase() === feature.toUpperCase();
  });
};

var isAABEnabled = isFeatureEnabled.bind(null, 'AAB');
var isABTestingEnabled = isFeatureEnabled.bind(null, 'ABTESTING');
var isAddressBookEnabled = isFeatureEnabled.bind(null, 'ADDRESSBOOK');
var isMyAccountEnabled = isFeatureEnabled.bind(null, 'MYACCOUNT');
var isContactLensEnabled = isFeatureEnabled.bind(null, 'CONTACTLENS');
var isContactLensStockEnabled = isFeatureEnabled.bind(null, 'CONTACTLENS_STOCK');
var isCrossSellEnabled = isFeatureEnabled.bind(null, 'CROSS_SELL');
var isReviewsEnabled = isFeatureEnabled.bind(null, 'REVIEWS');
var isSolutionsEnabled = isFeatureEnabled.bind(null, 'SOLUTIONS');
var isSearchEnabled = isFeatureEnabled.bind(null, 'SEARCH');
var isVtoEnabled = isFeatureEnabled.bind(null, 'VTO');
var isGPSEnabled = isFeatureEnabled.bind(null, 'GPS_STORES');
var isPlacePredictionsEnabled = isFeatureEnabled.bind(null, 'STORES_PLACE_PREDICTIONS');
var isMultilingualEnabled = isFeatureEnabled.bind(null, 'MULTILINGUAL');
var isPrescriptionGlassesEnabled = isFeatureEnabled.bind(null, 'PRESCRIPTION_GLASSES');
var isPrescriptionGlassesConfiguratorValidationStepEnabled = isFeatureEnabled.bind(null, 'PRESCRIPTION_GLASSES_CONFIGURATOR_VALIDATION_STEP');
var isPrescriptionFileEnabled = isFeatureEnabled.bind(null, 'PRESCRIPTION_FILE');
var isStoreSearchEnabled = isFeatureEnabled.bind(null, 'STORE_SEARCH');
var isSubscriptionHasOneAddressEnabled = isFeatureEnabled.bind(null, 'SUBSCRIPTION_HAS_ONE_ADDRESS');
var isSubscriptionUpdateAddressEnabled = isFeatureEnabled.bind(null, 'SUBSCRIPTION_UPDATE_ADDRESS');
var isCartV2Enabled = isFeatureEnabled.bind(null, 'CART_V2');

/***/ }),

/***/ "yLiY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setConfig = setConfig;
exports.default = void 0;
var runtimeConfig;

var _default = function _default() {
  return runtimeConfig;
};

exports.default = _default;

function setConfig(configValue) {
  runtimeConfig = configValue;
}

/***/ })

},[["+f1E",1,2,4,6,5,3,11,0,9]]]);